<template>
  <el-form
    :model="form"
    :disabled="disabledForm"
    ref="form">
    <h3 class="blue-text">{{L10n('rfq')}}</h3>
    <div class="row">
      <div class="col-md-3 col-12">
        <el-form-item
          :label="L10n('customer')"
          prop="customerCompanyID"
          :rules="getValidationRule('required')"
          class="material-style"
        >
          <select-company
            :model="form.customerCompanyID"
            disabled
            @on-data-value="(data) => updateViewData('customerName', data, 'name')"
            :clearable="false"
          />
        </el-form-item>
      </div>
      <div class="col-md-3 col-12">
        <el-form-item
          :label="L10n('customer-detail')"
          prop="customerCompanyDetailID"
          class="material-style">
          <select-company-detail
            withAutoSelect
            :model.sync="form.customerCompanyDetailID"
            :companyID="form.customerCompanyID"
            @update:model="updateModelItem('customerCompanyDetailID', { required: false })"
            :disabled="disabledForm"
          />
        </el-form-item>
      </div>
      <div class="col-md-3 col-12">
        <el-form-item
          :label="L10n('customer-contact')"
          prop="customerContactID"
          :rules="getValidationRule('required')"
          class="material-style">
          <select-company-contact
            :model.sync="form.customerContactID"
            :companyID="form.customerCompanyID"
            @update:model="updateModelItem('customerContactID', { required: true })"
            @on-data-value="(data) => updateViewData('customerContactName', data, 'name')"
            :disabled="disabledForm"
          />
        </el-form-item>
      </div>
      <div class="col-md-3 col-12">
        <el-form-item
          :label="L10n('customer-forwarder')"
          prop="customerForwarderID"
          class="material-style"
        >
          <select-forwarder
            :companyID="form.customerCompanyID"
            :model.sync="form.customerForwarderID"
            @update:model="updateModelItem('customerForwarderID', { required: false })"
            @on-data-value="(data) => updateViewData('customerForwarderName', data, 'forwarderShipperName')"
            :disabled="disabledForm"
            :clearable="false"
          />
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 col-12">
        <el-form-item
          :label="L10n('rfq-type')"
          prop="rfqTypeID"
          class="material-style"
          :rules="getValidationRule('required')"
        >
          <select-response
            :model.sync="form.rfqTypeID"
            @update:model="updateModelItem('rfqTypeID', { required: true })"
            @on-data-value="(data) => updateViewData('rfqTypeTitle', data, 'title')"
            :isLoading="dataSourceRfqType.loading"
            :data="dataSourceRfqType.records"
          />
        </el-form-item>
      </div>
      <div class="col-md-3 col-12">
        <el-form-item
          :label="L10n('employee')"
          prop="baxEmployeeID"
          class="material-style"
        >
          <select-response
            :model.sync="form.baxEmployeeID"
            @update:model="updateModelItem('baxEmployeeID', { required: false })"
            @on-data-value="(data) => updateViewData('baxEmployeeName', data, 'title')"
            :data="dataSourceEmployee.records"
            :isLoading="dataSourceEmployee.loading"
          />
        </el-form-item>
      </div>
      <div class="col-md-4 col-12">
        <el-form-item
          :label="L10n('observation')"
          prop="observation"
          class="material-style">
          <el-input
            v-model="form.observation"
            @change="updateModelItem('observation', { required: false })"
          />
        </el-form-item>
      </div>
      <div class="col-md-2 col-12">
        <el-form-item prop="pOisOpen" class="material-style">
          <el-checkbox
            v-model="form.pOisOpen"
            @change="handleChangePoIsOpen"
          >
            {{L10n('po-is-open')}}
          </el-checkbox>
        </el-form-item>
      </div>

      <div class="col-md-2 col-12">
        <el-form-item
          :label="L10n('po')"
          prop="po"
          class="material-style"
          :rules="getValidationRule('required')"
        >
          <el-input
            :value="form.po"
            @input="form.po = valueTrimLeft($event)"
            @change="updateModelItem('po', { required: true })"
          />
        </el-form-item>
      </div>
      <div class="col-md-2 col-12">
        <el-form-item
          :label="L10n('po-date')"
          :rules="getValidationRule('required')"
          prop="poDate"
          class="material-style"
        >
          <date-picker
            v-model="form.poDate"
            @change="updateModelItem('poDate', { required: true })"
          />
        </el-form-item>
      </div>
      <div class="col-md-2 col-12">
        <el-form-item
          :label="L10n('requested-date')"
          prop="requestedDate"
          class="material-style"
        >
          <date-picker
            v-model="form.requestedDate"
            @change="updateModelItem('requestedDate', { required: false })"
          />
        </el-form-item>
      </div>
      <div class="col-md-auto col-12">
        <el-form-item prop="step3" class="material-style">
          <el-checkbox
            v-model="form.step3"
            @change="updateModelItem('step3', { required: false })"
          >
            {{L10n('exchange-agreement-sent')}}
          </el-checkbox>
        </el-form-item>
      </div>
      <div class="col-md-auto col-12">
        <el-form-item prop="step1" :rules="getValidationRule('required')" class="material-style">
          <el-checkbox
            v-model="form.step1"
            @change="updateModelItem('step1', { required: true })"
          >
            <label-required>{{L10n('wdfl-ok')}}</label-required>
          </el-checkbox>
        </el-form-item>
      </div>
    </div>
    <view-more>
      <div class="row">
        <div class="col-xl-4 col-md-6 col-12">
          <el-form-item
            :label="L10n('ship-to-company')"
            prop="shipToCompanyID"
            :rules="getValidationRule('required')"
            class="material-style"
          >
            <select-company
              :model.sync="form.shipToCompanyID"
              @on-data-value="(data) => updateViewData('shipToCompanyName', data, 'name')"
              @on-created="mixCreateShipTo"
              @on-change="(id) => mixChangeShipToID(id)"
              :disabled="disabledForm"
              :cleareble="false"
            />
          </el-form-item>
        </div>
        <div class="col-xl-4 col-md-6 col-12">
          <el-form-item
            :label="L10n('ship-to-company-contact')"
            prop="shipToContactID"
            :rules="getValidationRule('required')"
            class="material-style">
            <select-company-contact
              :model.sync="form.shipToContactID"
              :companyID="form.shipToCompanyID"
              @on-data-value="(data) => updateViewData('shipToContactName', data, 'name')"
              @update:model="updateModelItem('shipToContactID', { required: true })"
              :disabled="disabledForm"
            />
          </el-form-item>
        </div>
        <div class="col-xl-4 col-md-6 col-12">
          <el-form-item
            :label="L10n('ship-to-company-detail')"
            prop="shipToCompanyDetailID"
            :rules="getValidationRule('required')"
            class="material-style">
            <select-company-detail
              :model.sync="form.shipToCompanyDetailID"
              :companyID="form.shipToCompanyID"
              @on-data-value="(data) => updateViewData('shipToCompanyDetailCountry', data, 'country')"
              @update:model="updateModelItem('shipToCompanyDetailID', { required: true })"
              :disabled="disabledForm"
            />
          </el-form-item>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 col-sm-6 col-12">
          <el-form-item
            :label="L10n('priority')"
            prop="priorityID"
            class="material-style">
            <select-response
              :model.sync="form.priorityID"
              @update:model="updateModelItem('priorityID', { required: false })"
              @on-data-value="(data) => updateViewData('priorityTitle', data, 'title')"
              :isLoading="dataSourcePriority.loading"
              :data="dataSourcePriority.records"
            />
          </el-form-item>
        </div>
        <div class="col-md-4 col-sm-6 col-12">
          <el-form-item
            :label="L10n('order-rating-score')"
            prop="orderRatingScoreID"
            :rules="rulesOrderScore"
            class="material-style"
          >
            <select-response
              :model.sync="form.orderRatingScoreID"
              @update:model="updateModelItem('orderRatingScoreID', { required: false })"
              @on-data-value="(data) => updateViewData('orderRatingScoreText', data, 'scoreText')"
              :fields="{ id: 'id', title: 'scoreText' }"
              :data="dataSourceScore.records"
              :isLoading="dataSourceScore.loading"
            />
          </el-form-item>
        </div>
        <div class="col-md-4 col-sm-6 col-12">
          <el-form-item
            :label="L10n('payment-term')"
            prop="paymentTermID"
            class="material-style">
            <select-response
              :model.sync="form.paymentTermID"
              @update:model="updateModelItem('paymentTermID', { required: false })"
              @on-data-value="(data) => updateViewData('paymentTermTitle', data, 'title')"
              :isLoading="dataSourcePaymentTerm.loading"
              :data="dataSourcePaymentTerm.records"
            />
          </el-form-item>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <el-form-item
            :label="L10n('company-remark')"
            prop="companyRemark"
            class="material-style">
            <el-input
              :value="customerCompanyRemark"
              type="textarea"
              readonly
            />
          </el-form-item>
        </div>
      </div>
    </view-more>
    <dialog-confirm-close-po
      v-if="isShowDialogConfirm"
      :rfqid="form.rfqid"
      @onClose="handleClosePoIsOpen"
      @onSuccess="handleSuccessPoIsOpen"
    />
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'
import { mixUpdateCustomer, mixUpdateShipTo } from '@/mixins/companies'
import { scoreDataSourceConverter } from '@/utils/shared'
export default {
  name: 'FormRFQ',
  mixins: [Form, mixUpdateCustomer, mixUpdateShipTo],
  components: {
    'view-more': () => import(/* webpackChunkName: 'UI' */ '@/components/UI/ViewMore.vue'),
    'label-required': () => import(/* webpackChunkName: 'UI' */ '@/components/UI/LabelRequired.vue'),
    'dialog-confirm-close-po': () => import(/* webpackChunkName: 'CustomerPoOpen' */ './DialogConfirmClosePo.vue'),
    'select-forwarder': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectForwarder/Index.vue'),
    'select-company': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompany/Index.vue'),
    'select-company-contact': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompanyContact/Index.vue'),
    'select-company-detail': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompanyDetail/Index.vue')
  },
  props: {
    dataID: { required: true }
  },
  data () {
    return {
      isShowDialogConfirm: false
    }
  },
  computed: {
    dataSourceEmployee () {
      return this.API('Employees/GetAllDynamic?select=id,name as title&filter=isActive==true')
    },
    dataSourceRfqType () {
      return this.API('RFQTypes/GetAllDynamic?select=id,title')
    },
    dataSourcePriority () {
      return this.API('Priorities/GetAllDynamic?select=id,title&orderBy=title')
    },
    dataSourcePaymentTerm () {
      return this.API('PaymentTerms/GetAllDynamic?select=id,title&orderBy=title')
    },
    dataSourceScore () {
      return scoreDataSourceConverter(this.API('Scores/GetAllDynamic?select=id,scoreText,scoreIndex&orderBy=scoreIndex'))
    },
    dataSourceRemarkSubject () {
      return this.API('CompanyRemarks/GetAllDynamic?Select=id,companyID,remark&filter=remarkSubjectID==6')
    },
    customerCompanyRemark () {
      const record = this.dataSourceRemarkSubject.records
        .find(({ companyID }) => {
          return companyID === this.form.customerCompanyID
        })
      return record && record.remark
    },
    rulesOrderScore () {
      return !this.form.pOisOpen
        ? this.getValidationRule('required')
        : undefined
    }
  },
  methods: {
    updateModelItem (fieldName, payload = {}) {
      let payloadMixin = { api: `RFQs/Patch/${this.dataID}`, id: this.dataID }
      this.$emit('updateModelItem', fieldName, this.form[fieldName], { ...payloadMixin, ...payload })
    },
    handleClosePoIsOpen () {
      this.form = { ...this.form, pOisOpen: true }
      this.isShowDialogConfirm = false
      this.updateModelItem('pOisOpen')
    },
    handleSuccessPoIsOpen () {
      this.form = { ...this.form, pOisOpen: false }
      this.isShowDialogConfirm = false
      this.updateModelItem('pOisOpen')
    },
    handleChangePoIsOpen (value) {
      if (!value) {
        this.isShowDialogConfirm = true
      } else {
        this.updateModelItem('pOisOpen')
      }
    }
  }
}
</script>
